const roles = {
  ADMIN: 'ROLE_ADMIN',
  ROLE_MANAGER: 'ROLE_MANAGER',
  ROLE_USER: 'ROLE_USER'
};

export default {
  roles: roles,
  authenSuccesUrlRedirect: function (hasAuthor) {
    // if (hasAuthor(roles.CREATE)) {
    //   return '/user-management/managed-users';
    // } else if (hasAuthor(roles.CREATE)) {
    //   return '/user-management/managed-users';
    // } else {
    //   return '/user-management/managed-users';
    // }
    return '/dashboard.html'
  },

  authorizationMapper: [
    {
      regex: /^\/dashboard.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.ROLE_MANAGER) || hasAuthor(roles.ROLE_USER);
      }
    },
    {
      regex: /^\/devices-management*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.ROLE_MANAGER) || hasAuthor(roles.ROLE_USER);
      }
    },
    {
      regex: /^\/files-screen-management*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.ROLE_MANAGER) || hasAuthor(roles.ROLE_USER);
      }
    },
    {
      regex: /^\/schedule-management*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.ROLE_MANAGER) || hasAuthor(roles.ROLE_USER);
      }
    },
    {
      regex: /^\/history-management*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.ROLE_MANAGER) || hasAuthor(roles.ROLE_USER);
      }
    },
    {
      regex: /^\/administrator*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.ROLE_MANAGER);
      }
    },
    {
      regex: /^\/administrator\/pi-action-config.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN);
      }
    },
    {
      regex: /^\/administrator\/thread.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN);
      }
    }
  ]
}
